var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayLoading = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61381 2.63013C6.91262 2.94907 5.37436 3.84727 4.2605 5.17207",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90798 7.56714C2.34613 9.18098 2.36051 10.9396 2.94867 12.544",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34082 14.9163C5.44747 16.193 6.95344 17.0577 8.61387 17.3699",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3643 2.62677C14.9212 3.28201 17.5033 6.38321 17.5033 10C17.5033 13.6168 14.9212 16.718 11.3643 17.3732",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11707 7.54733L12.3534 9.46146C12.5437 9.57395 12.6604 9.77856 12.6604 9.9996C12.6604 10.2206 12.5437 10.4252 12.3534 10.5377L9.11707 12.4519C8.9237 12.5662 8.68388 12.568 8.48877 12.4567C8.29367 12.3454 8.17327 12.1379 8.17334 11.9133V8.08588C8.17327 7.86125 8.29367 7.65383 8.48877 7.54249C8.68388 7.43115 8.9237 7.433 9.11707 7.54733V7.54733Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayLoading);
export default ForwardRef;